<template>
<div class="chapter">
<div class="inner_page">
<p class="toc-title"><i><span>Contents</span></i></p>
<p class="toc-entry"><a href="#/xhtml/chapter001"><span>1 <i>The Dream Book</i></span></a></p>
<p class="toc-entry"><a href="#/xhtml/chapter002"><span>2 <i>A Big Explosion</i></span></a></p>
<p class="toc-entry"><span href="#/xhtml/chapter003" title="Link target outside of Sample"><span>3 <i>The Celebration</i></span></span></p>
<p class="toc-entry"><span href="#/xhtml/chapter004" title="Link target outside of Sample"><span>4 “<i>This Is Your Thief</i>!”</span></span></p>
<p class="toc-entry"><span href="#/xhtml/chapter005" title="Link target outside of Sample"><span>5 <i>Some Kind of Hero</i></span></span></p>
<p class="toc-entry"><span href="#/xhtml/chapter006" title="Link target outside of Sample"><span>6 <i>Terrible News</i></span></span></p>
<p class="toc-entry"><span href="#/xhtml/chapter007" title="Link target outside of Sample"><span>7 <i>The Brown Suitcase</i></span></span></p>
<p class="toc-entry"><span href="#/xhtml/chapter008" title="Link target outside of Sample"><span>8 <i>Bill’s Bombshell</i></span></span></p>
<p class="toc-entry"><span href="#/xhtml/chapter009" title="Link target outside of Sample"><span>9 <i>Linda’s Party</i></span></span></p>
<p class="toc-entrya"><span href="#/xhtml/chapter010" title="Link target outside of Sample"><span>10 <i>Giggles and Buried Treasure</i></span></span></p>
<p class="toc-entrya"><span href="#/xhtml/chapter011" title="Link target outside of Sample"><span>11 <i>The Secret Window</i></span></span></p>
<p class="toc-entrya"><span href="#/xhtml/chapter012" title="Link target outside of Sample"><span>12 <i>Bad News from Gracie</i></span></span></p>
<p class="toc-entrya"><span href="#/xhtml/chapter013" title="Link target outside of Sample"><span>13 <i>A Long, Long Day</i></span></span></p>
<p class="toc-entrya"><span href="#/xhtml/chapter014" title="Link target outside of Sample"><span>14 <i>Trouble at the Picnic</i></span></span></p>
<p class="toc-entrya"><span href="#/xhtml/chapter015" title="Link target outside of Sample"><span>15 “<i>What’s Your Secret</i>?”</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?423adf48